export default "__VITE_ASSET__KcLFknG4__"